import {
  CertificateSeller,
  Product,
  Image,
  Contact,
  Coverage,
  Form,
  CustomerCertificate,
  CertificateStatusObject,
} from '../..';

export class Certificate {
  uuid: string;
  referenceId?: number;
  exemptionId?: number;
  form?: Form;
  notes?: string;
  certificateImage?: Image;
  supportingDocumentationImages?: Image[];
  syncId?: number;
  status?: CertificateStatusObject;
  classId?: number;
  className?: string;
  coverages?: Coverage[];
  certificateScope?: string;
  createdDateTime?: string;
  lastUpdatedDateTime?: string;
  effectiveDate?: string;
  endDate?: string;
  seller?: CertificateSeller;
  contact?: Contact;
  customer?: CustomerCertificate;
  documentNumber?: number;
  products?: Product[];
  customField1?: string;
  customField2?: string;
  customField3?: string;
  customField4?: string;
  customField5?: string;
  customField6?: string;
  customField7?: string;
  customField8?: string;
  customField9?: string;
  customField10?: string;
  source?: string;
  excludeFromSync?: boolean;
}
